import Login from "./components/Login/LoginForm";
import SignUp from "./components/Login/CreateAccount";
// import Dashboard from "./components/Dashboard/Dashboard";
import EmailVerification from "./components/EmailVerification/EmailVerification";
import Pricing from "./components/Pricing/Pricing";
// import Setting from "./components/Settings/SettingContainer";
import Setting from "./Containers/Settings/index";
import Help from "./components/Help/HelpContainer";
import ForgotPassword from "./components/Login/ForgotPassword";
import ResendActivation from "./components/Login/ResendActivation";
import Dashboard from "./Containers/Dashboard/index";
import ActivationSuccess from "./components/Login/ActivationSuccess";
import NotFound from "./components/NotFound";
import ResetPassword from "./components/Login/ResetPassword";
import RecurringPayment from "./components/RecurringPayment/RecurringPayment";
import SubscriptionPlans from "./components/Pricing/PricingContainer/SubscriptionPlansPreLogin";
import CompanyProfile from "./components/Login/companyProfile";
import SignupSuccess from "./components/Login/SignupSuccess";
const routes = [
  {
    id: "LoginForm",
    path: "/login",
    exact: true,
    component: Login,
    postLogin: false
  },
  {
    id: "signup",
    path: "/signup",
    exact: true,
    component: SignUp,
    postLogin: false
  },
  {
    id: "signup-success",
    path: "/signup-success",
    exact: true,
    component: SignupSuccess,
    postLogin: false
  },
  {
    id: "dashboard",
    path: "/dashboard",
    exact: true,
    component: Dashboard,
    postLogin: true
  },
  {
    id: "email-verification",
    path: "/email-verification",
    exact: true,
    component: EmailVerification,
    postLogin: true
  },
  {
    id: "pricing",
    path: "/pricing",
    exact: true,
    component: Pricing,
    postLogin: true
  },
  {
    id: "settings",
    path: "/settings",
    exact: true,
    component: Setting,
    postLogin: true
  },
  {
    id: "help",
    path: "/help",
    exact: true,
    component: Help,
    postLogin: true
  },
  {
    id: "forgotpassword",
    path: "/forgotpassword",
    exact: true,
    component: ForgotPassword,
    postLogin: false
  },
  {
    id: "resetpassword",
    path: "/resetpassword",
    exact: true,
    component: ResetPassword,
    postLogin: false
  },
  {
    id: "resendactivation",
    path: "/resendactivation",
    exact: true,
    component: ResendActivation,
    postLogin: false
  },
  {
    id: "activationsuccess",
    path: "/activationsuccess",
    exact: true,
    component: ActivationSuccess,
    postLogin: false
  },
  {
    id: "notfound",
    path: "/notfound",
    exact: true,
    component: NotFound,
    postLogin: false
  },
  {
    id: "recurringPayment",
    path: "/recurringPayment",
    exact: true,
    component: RecurringPayment,
    postLogin: true
  },
  {
    id: "subscriptionplans",
    path: "/subscriptionplans",
    exact: true,
    component: SubscriptionPlans,
    postLogin: false
  },
  {
    id: "cmopanyProfile",
    path: "/company-profile",
    exact: true,
    component: CompanyProfile,
    postLogin: false
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js